import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { FaQuoteLeft, FaStar } from "react-icons/fa";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Testimonials.css";

const testimonials = [
  {
    name: "Ashwini Darade",
    review:
      "The saree is lightweight and gorgeous! This was my first order from you for a saree and it is extremely beautiful. Love the feel and color."
  },
  {
    name: "Ashwini Darade",
    review:
      "So happy with the product... saree is same as shown in the pic.... highly recommended and the delivery was too fast...."
  },
  {
    name: "Abhilasha Rile",
    review:
      "Received the saree today Ma'am. Such a beautiful colour and the quality is excellent. Just like I wished for. Packing is very premium, overall authentic experience."
  },
  {
    name: "Supriya Rahul Jadhav",
    review:
      "Yet another absolute favourite purchase from yadnya handloom, saree is very beautiful, colour as expected, loved the fabric."
  },
  {
    name: "Swati Ghangurde",
    review:
      "Hello, Just received the parcel and Saree is absolutely beautiful and fabric is too good, it's little scary to buy online but I am glad you are selling what you show. I'm very happy with the purchase."
  },
  {
    name: "Verified Customer",
    review:
      "Thank you, Yadnya Handloom, for the beautiful handloom and warm service. Loved it! Grateful to Yadnya Handloom for such amazing quality...!"
  }
];

const Testimonials = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3500,
    speed: 600,
    slidesToShow: isMobile ? 1 : 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <section className="testimonial-section">
      <div className="testimonial-heading">
        <span>Testimonials</span>
        <h2>What Our Customers Say</h2>
        <p>
          Trusted by saree lovers across India for premium quality handloom collections.
        </p>
      </div>

      <div className="testimonial-slider-container">
        {/* key={isMobile} forces clean remount when switching views */}
        <Slider key={isMobile ? "mobile" : "desktop"} {...settings}>
          {testimonials.map((item, index) => (
            <div key={index} className="testimonial-slide">
              <div className="testimonial-card">
                <div className="card-top">
                  <FaQuoteLeft className="quote-icon" />
                  <div className="stars">
                    <FaStar />
                    <FaStar />
                    <FaStar />
                    <FaStar />
                    <FaStar />
                  </div>
                  <p className="review-text">{item.review}</p>
                </div>

                <div className="customer-info">
                  <div className="avatar">{item.name.charAt(0)}</div>
                  <div className="customer-details">
                    <h4>{item.name}</h4>
                    <span>Verified Customer</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Testimonials;